<script setup lang="ts">
import { computed, ref } from 'vue'

const props = withDefaults(defineProps<{
  text: string
  lines?: number
}>(), {
  lines: 2,
})

const expanded = ref(false)
const style = computed(() => ({ '--tm-expand-lines': String(Math.max(1, props.lines)) }))

function toggle(): void {
  expanded.value = !expanded.value
}
</script>

<template>
  <span
    class="tm-expandable-text"
    :class="{ 'is-expanded': expanded }"
    :style="style"
    :title="expanded ? undefined : text"
    role="button"
    tabindex="0"
    @click.stop="toggle"
    @keydown.enter.stop.prevent="toggle"
    @keydown.space.stop.prevent="toggle"
  >{{ text }}</span>
</template>

<style scoped>
.tm-expandable-text {
  display: -webkit-box;
  min-width: 0;
  max-width: 100%;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: var(--tm-expand-lines);
  white-space: normal;
  overflow-wrap: anywhere;
  cursor: pointer;
}

.tm-expandable-text.is-expanded {
  display: block;
  overflow: visible;
  -webkit-line-clamp: initial;
}
</style>
